import { Component, Input, OnInit } from '@angular/core';
import {
    Aangifte, AangifteBerekening,
    AangifteRapport, BokkzAlgDataService, Box1Berekening, Box2Berekening, Box3Berekening, IncomeTaxEntity,
    OpbouwBelastingBox2, OpbouwInkomenBox2,
    SpecificatieBelastingBox2, Wetgeving
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-spec-belasting-box2',
    templateUrl: './spec-belasting-box2.component.html',
    styleUrls: ['./spec-belasting-box2.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        CommonModule
    ]
})
export class SpecBelastingBox2Component implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte;
    public partnerBoolean = false;

    berekening = {} as AangifteBerekening;
    aangeverBerekening = {} as AangifteBerekening;
    partnerBerekening = {} as AangifteBerekening;

    specBelastingBox2FormGroup = this.fb.group<AangifteRapport>({});
    specBelastingBox2 = {} as AangifteRapport;
    berekeningBox2FormGroup = this.fb.group<AangifteBerekening>({});
    wetgevingFg = this.fb.group<Wetgeving>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specBelastingBox2FormGroup = this.fb.group<AangifteRapport>(({
            specificatieBelastingBox2: this.fb.group<SpecificatieBelastingBox2>(({
                opbouw: this.fb.group<OpbouwBelastingBox2>(({
                    berekendeIB: null as unknown as number,
                    box2VoorVoorkoming: null as unknown as number,
                    voorkomingBox2: null as unknown as number
                } as OpbouwBelastingBox2))
            } as SpecificatieBelastingBox2))
        } as AangifteRapport));
        this.berekeningBox2FormGroup = this.fb.group<AangifteBerekening>(({
            box2: this.fb.group<Box2Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                conserverendeAanslag: null as unknown as number
            } as Box2Berekening))
        } as AangifteBerekening));
        this.wetgevingFg = this.fb.group<Wetgeving>({
            box2PercentageSchijf1: null as unknown as number | undefined,
            box2PercentageSchijf2: null as unknown as number | undefined,
            maxInkomen1eSchijfBox2: null as unknown as number
        });
    }

    getWetgeving() {
        if (this.incomeTaxEntity.aangifte?.aangifteJaar === 2024) {
            this.wetgevingFg.patchValue({
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 33,
                maxInkomen1eSchijfBox2: 66999

            });
        } else if (this.incomeTaxEntity.aangifte?.aangifteJaar === 2025) {
            this.wetgevingFg.patchValue({
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 31,
                maxInkomen1eSchijfBox2: 67803
            });
        } else if (this.incomeTaxEntity.aangifte?.aangifteJaar === 2026) {
            this.wetgevingFg.patchValue({
                box2PercentageSchijf1: 24.5,
                box2PercentageSchijf2: 31,
                maxInkomen1eSchijfBox2: 68843
            });
        }
    }

    // public ngOnInit(): void {
    //     this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
    //         this.incomeTaxEntity = incomeTaxEntity;
    //         if (incomeTaxEntity.aangifte) {
    //             const aangifte = incomeTaxEntity.aangifte as Aangifte;
    //             this.aangifte = aangifte;
    //             this.dataService.aangifteRapport.subscribe((value) => {
    //                 this.specBelastingBox2 = value;
    //                 this.specBelastingBox2FormGroup.patchValue(this.specBelastingBox2);
    //             });
    //         }
    //     });
    //     this.getWetgeving();
    // }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity,
            this.dataService.aangifteBerekening,
            this.dataService.aangifteRapport,
            this.dataService.partnerAangifteRapport,
        ]).subscribe(
            ([incomeTaxEntity, berekening, aangeverRapport,partnerRapport]) => {
                this.specBelastingBox2FormGroup.reset();
                if (berekening) {
                    this.aangeverBerekening = berekening;
                    if (berekening.partnerBerekening) {
                        this.partnerBerekening = berekening.partnerBerekening;
                    }
                }
                if (incomeTaxEntity) {
                    this.getWetgeving()
                    this.incomeTaxEntity = incomeTaxEntity;
                    if (incomeTaxEntity.aangifte) {
                        const aangifte = incomeTaxEntity.aangifte as Aangifte;
                        this.aangifte = aangifte;
                        this.partner.subscribe((partner) => {
                            this.partnerBoolean = partner;
                            this.berekeningBox2FormGroup.reset();
                            this.specBelastingBox2FormGroup.reset();
                            if (partner) {
                                if (partnerRapport.specificatieBox3) {
                                    this.specBelastingBox2 = partnerRapport;
                                    this.specBelastingBox2FormGroup.patchValue(this.specBelastingBox2)
                                }
                                this.berekening = this.partnerBerekening;
                                this.berekeningBox2FormGroup.patchValue(this.berekening)
                            } else {
                                if (aangeverRapport.specificatieBox3) {
                                    this.specBelastingBox2 = aangeverRapport;
                                    this.specBelastingBox2FormGroup.patchValue(this.specBelastingBox2)
                                }
                                this.berekening = this.aangeverBerekening;
                                this.berekeningBox2FormGroup.patchValue(this.berekening)
                            }
                        });

                    }
                }
            });
    }
    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}
